// SPDX-License-Identifier: AGPL-3.0-or-later
import {VOICE_ENTRANCE_SOUND_TRACK_NAME} from '@app/features/voice/engine/VoiceEntranceSoundManager';
import type {LocalParticipant, LocalTrackPublication} from 'livekit-client';
import {Track} from 'livekit-client';

interface LocalParticipantWithAudioPublications extends Pick<LocalParticipant, 'audioTrackPublications'> {}
export function isMicrophoneSourcePublication(
	publication: Pick<LocalTrackPublication, 'source'> | null | undefined,
): boolean {
	return publication?.source === Track.Source.Microphone;
}
export function isControllableMicrophonePublication(
	publication: Pick<LocalTrackPublication, 'source' | 'trackName'> | null | undefined,
): boolean {
	if (!publication) {
		return false;
	}
	return isMicrophoneSourcePublication(publication) && publication.trackName !== VOICE_ENTRANCE_SOUND_TRACK_NAME;
}
export function getLocalMicrophonePublications(
	participant: LocalParticipantWithAudioPublications,
	options?: {
		includeEntranceSound?: boolean;
	},
): Array<LocalTrackPublication> {
	const includeEntranceSound = options?.includeEntranceSound ?? false;
	return Array.from(participant.audioTrackPublications.values()).filter(
		(publication): publication is LocalTrackPublication => {
			if (!publication) {
				return false;
			}
			return includeEntranceSound
				? isMicrophoneSourcePublication(publication)
				: isControllableMicrophonePublication(publication);
		},
	);
}
export function getPrimaryLocalMicrophonePublication(
	participant: LocalParticipantWithAudioPublications,
): LocalTrackPublication | null {
	return getLocalMicrophonePublications(participant)[0] ?? null;
}
